export class ObjectUtils {
  static isNullOrUndefined = (obj: any): boolean => {
    return obj === null || obj === undefined;
  }
  static isEmptyObject = (obj: any): boolean => {
    return this.isNullOrUndefined(obj) || (Object.keys(obj).length === 0 && obj.constructor === Object);
  }
}
